import { useEffect } from 'react';
import DOMPurify from 'dompurify';

// Sanitize content to prevent XSS in meta tags
const sanitizeContent = (content) => {
  if (!content) return '';
  // Remove HTML tags and sanitize
  return DOMPurify.sanitize(content, { ALLOWED_TAGS: [] });
};

// Sanitize URL to prevent injection
const sanitizeUrl = (url) => {
  if (!url) return '';
  try {
    // Validate it's a valid URL format
    const urlObj = new URL(url, window.location.origin);
    return urlObj.href;
  } catch {
    // If invalid, return empty string
    return '';
  }
};

const SEO = ({ title, description, keywords, image, url }) => {
  useEffect(() => {
    // Sanitize all inputs (Issue #10)
    const sanitizedTitle = sanitizeContent(title);
    const sanitizedDescription = sanitizeContent(description);
    const sanitizedKeywords = sanitizeContent(keywords);
    const sanitizedImage = sanitizeUrl(image || `${window.location.origin}/images/TMZ%20L.png`);
    const sanitizedUrl = sanitizeUrl(url || window.location.href);
    
    // Set document title
    if (sanitizedTitle) {
      document.title = `${sanitizedTitle} | TheMadZone`;
    }

    // Update or create meta tags
    const updateMetaTag = (name, content, isProperty = false) => {
      if (!content) return;
      
      const attribute = isProperty ? 'property' : 'name';
      let meta = document.querySelector(`meta[${attribute}="${name}"]`);
      
      if (!meta) {
        meta = document.createElement('meta');
        meta.setAttribute(attribute, name);
        document.head.appendChild(meta);
      }
      
      meta.setAttribute('content', content);
    };

    // Basic meta tags (using sanitized values)
    updateMetaTag('description', sanitizedDescription || 'TheMadZone - Premium Streetwear Fashion');
    updateMetaTag('keywords', sanitizedKeywords || 'streetwear, fashion, clothing, TheMadZone, urban fashion');
    
    // Open Graph tags (using sanitized values)
    updateMetaTag('og:title', sanitizedTitle || 'TheMadZone', true);
    updateMetaTag('og:description', sanitizedDescription || 'TheMadZone - Premium Streetwear Fashion', true);
    updateMetaTag('og:image', sanitizedImage, true);
    updateMetaTag('og:url', sanitizedUrl, true);
    updateMetaTag('og:type', 'website', true);
    
    // Twitter Card tags (using sanitized values)
    updateMetaTag('twitter:card', 'summary_large_image');
    updateMetaTag('twitter:title', sanitizedTitle || 'TheMadZone');
    updateMetaTag('twitter:description', sanitizedDescription || 'TheMadZone - Premium Streetwear Fashion');
    updateMetaTag('twitter:image', sanitizedImage);

    // Cleanup function
    return () => {
      // Reset to default on unmount if needed
      document.title = 'TheMadZone';
    };
  }, [title, description, keywords, image, url]);

  return null;
};

export default SEO;

